import { StandardButton, type StandardButtonProps } from './StandardButton';

const defaultText = 'Cancel';

interface Props extends Omit<StandardButtonProps, 'startIcon' | 'endIcon'> {}

export const CancelButton = (props: Props) => (
  <StandardButton text={defaultText} variant="outlined" {...props} />
);
